// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PWWx10dMjGpgmsbKgi3l{font-weight:bold;color:var(--color-main);margin-bottom:.5rem}`, "",{"version":3,"sources":["webpack://./src/components/forms/predefined/BuildLicenseListingTerms/components/RecognizerBenchmarks/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,gBAAA,CACA,uBAAA,CACA,mBAAA","sourcesContent":[".title\n  font-weight: bold\n  color: var(--color-main)\n  margin-bottom: .5rem"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `PWWx10dMjGpgmsbKgi3l`
};
export default ___CSS_LOADER_EXPORT___;
